import { transTreeToArr } from "@/utils/user"
import { getDepartmentTree } from "@/api/userCenter/company"
import { bfs } from "@/utils/algorithm"

export default {
  data() {
    return {
      initPromise: null
    }
  },
  computed: {
    departmentMap() {
      return this._.keyBy(transTreeToArr([this.rootDepartment]), "id")
    }
  },
  created() {
    this.initPromise = getDepartmentTree().then(
      departmentTree => (this.rootDepartment = departmentTree[0])
    )
  },
  methods: {
    getFilterDepartmentIds(departments) {
      let result = []
      if (this.includeSubDepartment) {
        departments.forEach(item => {
          let department = this.departmentMap[item.value]
          if (!department) return
          bfs({
            arr: [department],
            childFuc: dm => dm.children,
            cbk: dm => result.push({ value: dm.id, var: false })
          })
        })
      }
      return result
    }
  }
}
